import { useState, useEffect } from 'react';

import { GatsbyImage } from 'gatsby-plugin-image';

import Button from '@/components/atoms/button/button';
import PdfViewModal from '@/components/molecules/pdf-view-modal/pdfViewModal';

import './stateOfHousingAllowanceResult.scss';
import { StateData } from '../state-of-housing-allowance/stateOfHousingAllowance.adapter';

type StateDataItem = StateData[string];

const StateOfHousingAllowanceResult = ({
  contentInfo,
  states,
  postulationData,
  onClickBack,
  buttonLoader,
}: any) => {
  const [stateData, setStateData] = useState<StateDataItem | null>(null);
  const [serviceChannel, setServiceChannel] = useState<any>(null);
  const [visualizationModal, setVisualizationModal] = useState<any>(null);

  useEffect(() => {
    // eslint-disable-next-line dot-notation
    setStateData(states[postulationData.idEstado] || states['E0000']);
    setServiceChannel(contentInfo[1]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const viewPdf = () => {
    setVisualizationModal(
      <PdfViewModal
        base64={postulationData.certificadoB64}
        setActiveModal={setVisualizationModal}
        selectedFileName="Certificado de afiliacion"
        setActiveToast={() => false}
      />,
    );
  };

  const renderImage = (imageData) => {
    if (imageData?.gatsbyImage) {
      return (
        <GatsbyImage
          image={imageData.gatsbyImage}
          alt={imageData.title}
          title={imageData.title}
          loading="eager"
        />
      );
    }
    return <img src={imageData.file.url} alt={imageData.title} />;
  };

  if (!stateData) {
    return null;
  }

  return (
    <div className="o-state-of-housing-allowance">
      <article className="o-state-of-housing-allowance__card">
        <figure className="o-state-of-housing-allowance__image">
          {renderImage(stateData.media)}
        </figure>
        <div className="o-state-of-housing-allowance__card__title">
          <p>{`${stateData.title.split('!')[0]}!`}</p>
          <p>{stateData.title.split('!')[1]}</p>
        </div>
        <div className="o-state-of-housing-allowance__card__subtitle">
          <p>{stateData.subtitle}</p>
        </div>
      </article>

      <article className="o-state-of-housing-allowance__card">
        <div className="o-state-of-housing-allowance__card__title">
          <p>{contentInfo[2].nombre}</p>
        </div>
        <div className="o-state-of-housing-allowance__card__subtitle">
          <p>{contentInfo[2].subtitulo}</p>
        </div>
        <hr className="o-state-of-housing-allowance__line" />

        <aside className="o-state-of-housing-allowance__listInfo">
          <p>
            <span className="o-state-of-housing-allowance__header">{contentInfo[2].lista[0]}</span>
            <span className="o-state-of-housing-allowance__content">
              {postulationData.nombre || 'N/A'}
            </span>
          </p>
          <p>
            <span className="o-state-of-housing-allowance__header">{contentInfo[2].lista[1]}</span>
            <span className="o-state-of-housing-allowance__content">
              {postulationData.documento || 'N/A'}
            </span>
          </p>
          <p>
            <span className="o-state-of-housing-allowance__header">{contentInfo[2].lista[2]}</span>
            <span className="o-state-of-housing-allowance__content">
              {postulationData.formulario || 'N/A'}
            </span>
          </p>
        </aside>
        <aside className="o-state-of-housing-allowance__listInfo">
          <p>
            <span className="o-state-of-housing-allowance__header">{contentInfo[2].lista[3]}</span>
            <span className="o-state-of-housing-allowance__content">
              {postulationData.fechaEstado || 'N/A'}
            </span>
          </p>

          <p>
            <span className="o-state-of-housing-allowance__header">{contentInfo[2].lista[4]}</span>
            <span className="o-state-of-housing-allowance__content">
              {postulationData.estadoPostulacion || 'N/A'}
            </span>
          </p>

          <p>
            <span className="o-state-of-housing-allowance__header">{contentInfo[2].lista[5]}</span>
            <span className="o-state-of-housing-allowance__content">
              {postulationData.valor || 'N/A'}
            </span>
          </p>
        </aside>

        {(stateData.config.showBackButton || stateData.config.showCertificateButton) && (
          <aside className="o-state-of-housing-allowance__buttons">
            {contentInfo[2].boton && (
              <>
                <Button
                  type="button"
                  classname="two"
                  text={contentInfo[2].boton[0].copy}
                  onClickAction={onClickBack}
                  isDisabled={false}
                  loader={buttonLoader}
                />
                {stateData.config.showCertificateButton && (
                  <Button
                    type="button"
                    classname="one"
                    text={contentInfo[2].boton[1].copy}
                    onClickAction={viewPdf}
                    isDisabled={!postulationData.certificadoB64}
                    loader={buttonLoader}
                  />
                )}
              </>
            )}
          </aside>
        )}
      </article>

      {stateData.config.showServiceChannel && (
        <article className="o-state-of-housing-allowance__card">
          <div className="o-state-of-housing-allowance__card__title">
            <p>{serviceChannel.nombre!}</p>
          </div>
          <div className="o-state-of-housing-allowance__card__subtitle">
            <p>{serviceChannel?.subtitulo}</p>
          </div>
          <hr className="o-state-of-housing-allowance__line" />
          <aside className="o-state-of-housing-allowance__listInfoWrong">
            {serviceChannel.referencias.map((elem, index) => (
              <a key={index} href={elem.redireccion || '#'}>
                <figure className="o-state-of-housing-allowance__image__wrong">
                  {renderImage(elem.imagen[0])}
                </figure>
                <span className="o-state-of-housing-allowance__header">{elem.nombre}</span>
                <span className="o-state-of-housing-allowance__content">{elem.subtitulo}</span>
              </a>
            ))}
          </aside>
        </article>
      )}
      {visualizationModal && <>{visualizationModal}</>}
    </div>
  );
};

export default StateOfHousingAllowanceResult;
